<template>
  <b-row>
    <b-col>
      <b-card
        class="mb-0 mt-0"
        body-class="p-2">
        <b-row align-h="end">
          <b-col cols="2">
            <b-button
              class="btn-test"
              style="width:120px;"
              variant="success"
              @click="modal.allAISurveillanceStart=true">
              <span>全開始</span>
            </b-button>
          </b-col>
          <b-col cols="2">
            <b-button
              class="btn-test"
              style="width:120px;"
              @click="modal.allAISurveillanceStop=true">
              <span>全停止</span>
            </b-button>
          </b-col>
          <!-- 最新更新日時 -->
          <b-col cols="2">
            <span class="h8" style="display: block; text-align: right;">更新時刻：{{lastScreenUpdateTime}}</span>
          </b-col>
        </b-row>
        <br>
        <b-table
          :items="monitoringItems"
          :fields="tableFields"
          :empty-text="'データがありません'"
          hover
          responsive
          show-empty
          class="p-1 text-nowrap table-sm"
          no-local-sorting>
          <!-- 踏切名 -->
          <template v-slot:cell(crossingName)="data">
            <span
              class="text-wrap text-center"
              style="font-size: 17px;">
              {{ data.item.crossingName }}
            </span>
          </template>

          <!-- カメラ設置場所 -->
          <template v-slot:cell(locationName)="data">
            <span
              class="text-wrap text-center"
              style="font-size: 17px;">
              {{ data.item.locationName }}
              <b-badge
                v-if="data.item.trial !== 0"
                variant="warning">
                {{ selectTrialStatus[data.item.trial] }}
              </b-badge>
            </span>
          </template>

          <!-- エッジ稼働状態 -->
          <template v-slot:cell(edgeDeviceStatus)="data">
            <h4>
              <b-badge
                :id="createId('edgeDeviceStatusId', data.item)"
                :variant="selectEdgeDeviceStatusColor[data.item.edgeDeviceStatus]"
                style="width:150px;">
                {{ selectEdgeDeviceStatusName[data.item.edgeDeviceStatus] }}
              </b-badge>
              <b-tooltip
                v-if="data.item.aliveStatus === 1 && data.item.edgeDeviceStatus === 99"
                variant="warning"
                :target="createId('edgeDeviceStatusId', data.item)">
                <div style="text-align: left; white-space: pre-line">
                  <b>{{data.item.edgeDeviceErrorType}}</b>
                </div>
              </b-tooltip>
            </h4>
          </template>

          <!-- AI監視状態 -->
          <template v-slot:cell(AISurveillanceStatus)="data">
            <h4>
              <b-badge
                :variant="selectAiStatusColor[data.item.AISurveillanceStatus]"
                style="width:120px;">
                {{ selectAiStatusName[data.item.AISurveillanceStatus] }}
              </b-badge>
            </h4>
          </template>

          <!-- エッジデバイス監視状態変更ボタン -->
          <template v-slot:cell(edgeSurveillanceStatus)="data">
            <b-button
              class="btn-test"
              v-if="data.item.edgeSurveillanceStatus === 0"
              @click="modal.AISurveillanceStart=true; getEdgeId(data.item.edgeId);"
              :variant="selectEdgeSurveillanceChangeButtonColor[data.item.edgeSurveillanceStatus]">
              {{ selectEdgeSurveillanceName[data.item.edgeSurveillanceStatus] }}
            </b-button>

            <b-button
              class="btn-test"
              v-if="data.item.edgeSurveillanceStatus === 1"
              @click="modal.AISurveillanceStop=true; getEdgeId(data.item.edgeId);"
              :variant="selectEdgeSurveillanceChangeButtonColor[data.item.edgeSurveillanceStatus]">
              {{ selectEdgeSurveillanceName[data.item.edgeSurveillanceStatus] }}
            </b-button>
          </template>

          <!-- 試運用モード変更ボタン 2023/03 ADD -->
          <template v-slot:cell(trial)="data">
            <!-- 試運用開始ボタン -->
            <b-button
              class="btn-test"
              v-if="data.item.trial === 0"
              @click="modal.trialModeStart=true; getEdgeId(data.item.edgeId);"
              :variant="selectTrialModeChangeButtonColor[data.item.trial]">
              {{ selectTrialModeName[data.item.trial] }}
            </b-button>
            <!-- 試運用終了ボタン -->
            <b-button
              class="btn-test"
              v-if="data.item.trial === 1"
              @click="modal.trialModeStop=true; getEdgeId(data.item.edgeId);"
              :variant="selectTrialModeChangeButtonColor[data.item.trial]">
              {{ selectTrialModeName[data.item.trial] }}
            </b-button>
            <!-- テスト終了ボタン -->
            <b-button
              class="btn-test"
              v-if="data.item.trial === 2"
              @click="modal.testModeStop=true; getEdgeId(data.item.edgeId);"
              :variant="selectTrialModeChangeButtonColor[data.item.trial]">
              {{ selectTrialModeName[data.item.trial] }}
            </b-button>
          </template>

          <!-- ライブカメラリンク -->
          <template v-slot:cell(liveCamLink)="data">
            <div v-if='data.item.safieToken != null'>
              <a
                @click="linkToOtherWindow(data)"
                href="javascript:void(0)"
              >
                <span>ライブカメラ</span>
              </a>
            </div>
          </template>

        </b-table>
      </b-card>
    </b-col>

    <!-- 停止確認モーダル -->
    <b-modal
      v-model="modal.AISurveillanceStop"
      title="AI監視停止確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>AI監視を停止しますが、よろしいでしょうか？</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="AIMonitoringStop()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

    <!-- 開始確認モーダル -->
    <b-modal
      v-model="modal.AISurveillanceStart"
      title=" AI監視開始確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>AI監視を開始しますが、よろしいでしょうか？</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="AIMonitoringStart()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

    <!-- 全停止確認モーダル -->
    <b-modal
      v-model="modal.allAISurveillanceStop"
      title=" AI監視停止確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>AI監視をすべて停止しますが、よろしいでしょうか？</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="allAIMonitoringStop()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

    <!-- 全開始確認モーダル -->
    <b-modal
      v-model="modal.allAISurveillanceStart"
      title=" AI監視開始確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>AI監視をすべて開始しますが、よろしいでしょうか？</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="allAIMonitoringStart()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>

    <!-- 試運用モード変更ボタン 2023/03 ADD -->
    <b-modal
      v-model="modal.trialModeStart"
      title=" 試運用モード開始確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>試運用モードに変更しますが、よろしいでしょうか？<br /><br />
      試運用モードに変更すると、AIカメラの発報が解除され、AIカメラが人を検知した際に特殊信号発光機が点灯しなくなります。<br />
      試運用モード時の発報を確認する場合は、通知・発報履歴一覧画面の検索条件で「試運用フラグ」にチェックを入れて検索してください。</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="trialModeStart()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="modal.trialModeStop"
      title=" 試運用モード終了確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>試運用モードを終了し、通常運用モードに戻りますが、よろしいでしょうか？<br /><br />
      通常運用モードに戻ると、AIカメラが人を検知した際に特殊信号発光機が点灯するようになります。</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="trialModeStop()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <b-modal
      v-model="modal.testModeStop"
      title=" 検知エリア確認テスト終了確認"
      header-bg-variant="warning"
      hide-header-close
      no-close-on-esc
      no-close-on-backdrop>
      <span>検知エリア確認テストを終了しますが、よろしいでしょうか？<br /><br />
      検知エリア確認テスト終了後は試運用モードに切り替わりますので、AIカメラが人を検知した際に特殊信号発光機が点灯しません。<br /><br />
      検知エリア確認テスト終了後に試運用モードも終了することで、AIカメラが人を検知した際に特殊信号発光機が点灯するようになります。</span>
      <template v-slot:modal-footer="{ cancel }">
        <b-button
          variant="secondary"
          @click="cancel()">
          <span>Cansel</span>
        </b-button>
        <b-button
          variant="primary"
          @click="testModeStop()">
          <span>OK</span>
          <b-spinner
            v-show="isProcessing"
            class="ml-1"
            small>
          </b-spinner>
        </b-button>
      </template>
    </b-modal>
    <!-- 試運用モード変更ボタン 2023/03 END -->

  </b-row>
</template>
<script>

import API from '@/api'
import {mapGetters, mapMutations} from "vuex";
import moment from 'moment';

const POLLING_INTERVAL = process.env.VUE_APP_POLLING_INTERVAL
const MONITORING_START = 1
const MONITORING_STOP = 0
const WINDOW_FEATURES = "menubar=no,location=no,resizable=yes,scrollbars=yes,status=no,width=800,height=640"

// 特発強制解除機能追加 2023/03 ADD
const TRIAL_START = 1
const TRIAL_STOP = 0
const TEST_STOP = 1

const DEBUG = parseInt(process.env.VUE_APP_DEBUG)
const debug = msg => {
  if (DEBUG === 1)
    console.log(msg)
}

export default {
  name: "Monitoring",
  data() {
    return {
      // ダイアログを多重に表示させない為のフラグ
      alreadyDialogDisplayed: false,
      // エラーダイアログの表示状態
      alreadyErrorDialogDisplayed: false,

      // 定周期タイマー
      updateTimer: null,

      // 画面最新更新日時
      lastScreenUpdateTime: null,

      // APIから取得した状態一覧
      monitoringItems: [],

      // 選択行のエッジID
      selectedEdgeId: null,

      // モーダルの表示状態
      modal: {
        AISurveillanceStop: false,
        AISurveillanceStart:false,
        allAISurveillanceStop: false,
        allAISurveillanceStart: false
      },
    };
  },

  async created() {
    await this.initialize();
  },
  // 画面遷移時に定周期処理を停止する
  beforeDestroy() {
    clearInterval(this.updateTimer)
  },
  methods: {
    ...mapMutations("componentState", [
      'turnLoadingOn',
      'turnLoadingOff',
    ]),

    // AI停止・開始用パラメータ
    monitoringStatusParams(monitoringStatus, edgeFlg) {
      const item = this.monitoringItems
      const targets = []
      if (edgeFlg) {
        targets.push({
          edgeId: Number(this.selectedEdgeId)
        })
      } else {
        item.forEach(function(data) {
          targets.push({
            edgeId: Number(data.edgeId)
          })
        })
      }
      return {
        clientId: Number(this.clientId),
        affiliationId: Number(this.affiliationId),
        purosesuType: monitoringStatus,
        targets: targets
      }
    },

    //初期処理
    async initialize() {
      const data = await this.fetchMonitoringStatus()
      this.bindingTableMonitoringItems(data)
      // 自動更新の設定
      this.setEdgeDeviceStatusAutoRefreshTimer()
    },

    bindingTableMonitoringItems(data){
      if (data) {
        this.lastScreenUpdateTime = moment().format("HH:mm:ss")
        const edgeDeviceErrorType = this.getEdgeDeviceErrorType()
        var multipleErrorType = []
        data.forEach(function(data) {
          data.edgeSurveillanceStatus = data.AISurveillanceStatus
          // 死活状態が異常の場合
          if (data.aliveStatus === 1) {
            if (data.edgeErrors.length > 1) {
              var setReflectErrorCount = 0
              let showErrorTypeId = 0
              data.edgeErrors.forEach(function(item) {
                // 設定書込異常のカウント
                if (item.errorTypeId === 9 || item.errorTypeId === 10) {
                  setReflectErrorCount = setReflectErrorCount + 1
                }
                // 設定書込異常を複数件表示しないように処理
                if (setReflectErrorCount < 2 || !(item.errorTypeId === 9 || item.errorTypeId === 10)) {
                  multipleErrorType.push(edgeDeviceErrorType[item.errorTypeId])
                  showErrorTypeId = item.errorTypeId
                }
              })
              data.edgeDeviceErrorType = multipleErrorType.join('\n')
              if (multipleErrorType.length > 1) {
                data.edgeDeviceStatus = 99
              } else {
                data.edgeDeviceStatus = showErrorTypeId
              }
              multipleErrorType = []
            } else {
              data.edgeDeviceStatus = data.edgeErrors[0].errorTypeId
            }
          } else {
            data.edgeDeviceStatus = data.aliveStatus
          }
        })
        this.monitoringItems = data
      }
    },

    // 異常種別IDを取得
    getEdgeDeviceErrorType(){

      const edgeDeviceErrorType = {
        1: 'カメラ接続異常',
        2: '開始信号異常',
        3: '列車信号異常',
        4: 'DIO接続異常',
        5: 'NW接続異常',
        6: '設定反映異常',
        7: 'エッジデバイス異常',
        8: 'エッジ通信異常',
        9: '設定書込異常',
        10: '設定書込異常',
      }

      return edgeDeviceErrorType

    },

    // 状態一覧取得
    async fetchMonitoringStatus() {
      try {
        const result = await API.monitoring.get(this.idToken(), {
          path: '?client_id=' + this.clientId +
                '&affiliation_id=' + this.affiliationId
        })
        return result.data
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          this.makeToast(
            'エッジデバイスの状態一覧の取得エラー',
            `エッジデバイスの状態一覧の一覧の取得に失敗しました。(${err.message})`,
            'warning')
        }
        return
      }
    },

    // 通知バナーの表示
    makeToast(title, message, variant = 'info') {
      this.$bvToast.toast(message, {
        title: title,
        autoHideDelay: 8000,
        variant: 'warning',
      })
    },

    // 定周期で動作する関数
    setEdgeDeviceStatusAutoRefreshTimer() {
      let isInProgress = false
      this.updateTimer = setInterval(async () => {
        if (isInProgress) return
        isInProgress = true
        try {
          const data = await this.fetchMonitoringStatus()
          this.bindingTableMonitoringItems(data)
        } catch (err) {
          debug(err)
        } finally {
          isInProgress = false
        }
      }, POLLING_INTERVAL)
    },

    // ID作成
    createId(fixId, item) {
      return fixId + item.__ob__.dep.id
    },

    // 選択行のエッジIDを取得
    getEdgeId(edgeId) {
      this.selectedEdgeId = edgeId
    },

    // 開始ボタン押下時
    async AIMonitoringStart() {
      this.turnLoadingOn();
      try {
        await API.monitoring.post(this.idToken(), {
          data: this.monitoringStatusParams(MONITORING_START, true)})
        this.$bvModal.msgBoxOk(
            `AI監視の開始を要求しました。`, this.successDialogProps)
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          await this.showErrorDialog(`AI監視の開始要求に失敗しました。(${err.message})`)
        }
      }
      this.turnLoadingOff();
      this.modal.AISurveillanceStart = false
    },

    // 停止ボタン押下時
    async AIMonitoringStop() {
      this.turnLoadingOn();
      try {
        await API.monitoring.post(this.idToken(), {
          data: this.monitoringStatusParams(MONITORING_STOP, true)})
          this.$bvModal.msgBoxOk(
            `AI監視の停止を要求しました。`, this.successDialogProps)
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          await this.showErrorDialog(`AI監視の停止要求に失敗しました。(${err.message})`)
        }
      }
      this.turnLoadingOff();
      this.modal.AISurveillanceStop = false
    },

    // 全開始ボタン押下時
    async allAIMonitoringStart() {
      this.turnLoadingOn();
      try {
        await API.monitoring.post(this.idToken(), {
          data: this.monitoringStatusParams(MONITORING_START, false)})
          this.$bvModal.msgBoxOk(
            `AI監視の全開始を要求しました。`, this.successDialogProps)
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          await this.showErrorDialog(`AI監視の全開始要求に失敗しました。(${err.message})`)
        }
      }
      this.turnLoadingOff();
      this.modal.allAISurveillanceStart = false
    },

    // 全停止ボタン押下時
    async allAIMonitoringStop() {
      this.turnLoadingOn();
      try {
        await API.monitoring.post(this.idToken(), {
          data: this.monitoringStatusParams(MONITORING_STOP, false)})
          this.$bvModal.msgBoxOk(
            `AI監視の全停止を要求しました。`, this.successDialogProps)
      } catch (err) {
        // セッションタイムアウト判定
        if (err.response && err.response.status === 403) {
          return this.$router.push({path: '/session-timeout'})
        } else {
          await this.showErrorDialog(`AI監視の全停止要求に失敗しました。(${err.message})`)
        }
      }
      this.turnLoadingOff();
      this.modal.allAISurveillanceStop = false
    },

    // 特発強制停止機能追加 2023/03 ADD START
    async trialModeStart() {
      this.turnLoadingOn();
       try {
          var params = {}
          params.edgeId = Number(this.selectedEdgeId)
          params.processType = Number(TRIAL_START)

          await API.monitoring.patch(
            this.idToken(), {data: params})
          this.$bvModal.msgBoxOk(
            `試運用を開始しました。`, this.successDialogProps)
        } catch (err) {
          // セッションタイムアウト判定
          if (err.response && err.response.status === 403) {
            return this.$router.push({path: '/session-timeout'})
          } else {
            await this.showErrorDialog(`試運用の開始要求に失敗しました。(${err.message})`)
          }
        }

      this.modal.trialModeStart = false
      this.turnLoadingOff();

      // 一覧情報を更新
      await this.initialize()
    },

    async trialModeStop() {
      this.turnLoadingOn();
       try {
          var params = {}
          params.edgeId = Number(this.selectedEdgeId)
          params.processType = Number(TRIAL_STOP)

          await API.monitoring.patch(
            this.idToken(), {data: params})
          this.$bvModal.msgBoxOk(
            `試運用を終了しました。`, this.successDialogProps)
        } catch (err) {
          // セッションタイムアウト判定
          if (err.response && err.response.status === 403) {
            return this.$router.push({path: '/session-timeout'})
          } else {
            await this.showErrorDialog(`試運用の終了要求に失敗しました。(${err.message})`)
          }
        }

      this.modal.trialModeStop = false
      this.turnLoadingOff();

      // 一覧情報を更新
      await this.initialize()
    },

    async testModeStop() {
      this.turnLoadingOn();
       try {
          var params = {}
          params.edgeId = Number(this.selectedEdgeId)
          params.processType = Number(TEST_STOP)

          await API.monitoring.patch(
            this.idToken(), {data: params})
          this.$bvModal.msgBoxOk(
            `検知エリア確認テストモードを終了しました。`, this.successDialogProps)
        } catch (err) {
          // セッションタイムアウト判定
          if (err.response && err.response.status === 403) {
            return this.$router.push({path: '/session-timeout'})
          } else {
            await this.showErrorDialog(`検知エリア確認テストモードの終了要求に失敗しました。(${err.message})`)
          }
        }
      
      this.modal.testModeStop = false
      this.turnLoadingOff();

      // 一覧情報を更新
      await this.initialize()
    },
    // 特発強制停止機能追加 2023/03 ADD END

    async showModal(modal) {
      if (this.alreadyDialogDisplayed) return true
      this.alreadyDialogDisplayed = true

      await this.$bvModal.msgBoxOk(
        [modal.message],
        {
          okTitle: '閉じる',
          hideHeaderClose: true,
          noCloseOnEsc: false,
          noCloseOnBackdrop: false,
          centered: true,
          size: 'huge',
          headerClass: 'p-0 border-bottom-0',
          bodyClass: 'pb-0',
          footerClass: 'pb-2 border-top-0',
          buttonSize: 'md',

        }
      )
        .catch(() => {
          this.alreadyDialogDisplayed = false
        })
      this.alreadyDialogDisplayed = false
    },
    async showErrorDialog(errorMessage) {
      this.alreadyDialogDisplayed = true
      // 既にエラーダイアログが表示されている場合は重ねて表示しない
      if (this.alreadyErrorDialogDisplayed === true) return
      this.alreadyErrorDialogDisplayed = true
      await this.$bvModal.msgBoxOk(
        `${errorMessage}`, this.errorDialogProps)
        .then(async () => {
        })
        .catch(() => {
          this.alreadyDialogDisplayed = false
          this.alreadyErrorDialogDisplayed = false
        })
      this.alreadyDialogDisplayed = false
      this.alreadyErrorDialogDisplayed = false
    },
    // ライブカメラリンク押下
    linkToOtherWindow(data) {
      let resolvedRoute = this.$router.resolve({
        name: 'LiveCamera',
        query: {
          safieToken: data.item.safieToken,
          safieDeviceId: data.item.safieDeviceId,
        }
      })
      const windowName = 'LiveCamera_' + data.item.safieDeviceId
      let test = window.open(resolvedRoute.href, windowName, WINDOW_FEATURES)
    },
  },
  computed: {
    ...mapGetters("auth", ['idToken','clientId','affiliationId']),
    ...mapGetters("componentState", ['isProcessing']),

    errorDialogProps() {
      return {
        title: 'エラー',
        headerBgVariant: 'danger',
        hideHeaderClose: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      }
    },

    // 成功ダイアログのプロパティ
    successDialogProps() {
      return {
        title: '成功',
        headerBgVariant: 'success',
        hideHeaderClose: true,
        noCloseOnEsc: true,
        noCloseOnBackdrop: true
      }
    },
    selectAiStatusColor() {
      return {
        1: 'success',
        0: 'secondary'
      }
    },
    selectAiStatusName() {
      return {
        1: '監視中',
        0: '停止中'
      }
    },
    selectEdgeDeviceStatusColor() {
      return {
        0: 'success',
        1: 'danger',
        2: 'danger',
        3: 'danger',
        4: 'danger',
        5: 'danger',
        6: 'danger',
        7: 'danger',
        8: 'danger',
        9: 'danger',
        10: 'danger',
        99: 'danger'
      }
    },
    selectEdgeDeviceStatusName() {
      return {
        0: '正常',
        1: 'カメラ接続異常',
        2: '開始信号異常',
        3: '列車信号異常',
        4: 'DIO接続異常',
        5: 'NW接続異常',
        6: '設定反映異常',
        7: 'エッジデバイス異常',
        8: 'エッジ通信異常',
        9: '設定書込異常',
        10: '設定書込異常',
        99: '複数異常'
      }
    },
    selectEdgeSurveillanceName() {
      return {
        1: '停止',
        0: '開始'
      }
    },
    selectEdgeSurveillanceChangeButtonColor() {
      return {
        1: '',
        0: 'success',
        9: ''
      }
    },
    selectTrialStatus() { // 2021/10/07 テストモード追加
      return {
        2: 'テスト',
        1: '試運用',
        0: ''
      }
    },

    // 特発強制停止機能追加 2023/03 ADD START
    selectTrialModeName() {
      return {
        0: '試運用開始',
        1: '試運用終了',
        2: 'テスト終了'
      }
    },
    selectTrialModeChangeButtonColor() {
      return {
        0: 'success',
        1: 'success',
        2: 'success'
      }
    },
    // 特発強制停止機能追加 2023/03 ADD END

    tableFields() {
      return [
        {
          key: "crossingName",
          label: "踏切名",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "locationName",
          label: "カメラ設置場所",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "edgeDeviceStatus",
          label: "エッジ稼働状態",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "AISurveillanceStatus",
          label: "AI監視状態",
          sortable: false,
          tdClass: "align-middle"
        },
        {
          key: "edgeSurveillanceStatus",
          label: "AI監視切替",
          sortable: false,
          tdClass: "align-middle"
        },

        // 特発強制停止機能追加 2023/03 ADD
        {
          key: "trial",
          label: "運用切替",
          sortable: false,
          tdClass: "align-middle"
        },

        {
          key: "liveCamLink",
          label: "現地映像",
          sortable: false,
          tdClass: "align-middle"
        }
      ]
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal-image {
    width: auto;
    height: auto;
    max-height: calc(100vh - 180px);
  }

  .px-12p {
    padding-left: 12px;
    padding-right: 12px;
  }

  .table_vertical {
    vertical-align: middle
  }

  .btn-test {
      border: solid 1px #000000;
      width:110px;
      color: #000000;
  }

  .badge-secondary {
      color: #ffffff;
      background-color: #949a9e;
  }

</style>
